<qrcode [qrdata]="qrcodeData" [width]="150" [errorCorrectionLevel]="'H'"></qrcode>